import HighlightAlterrnateImage from '../../../assets/images/highlight-alterrnate-image.jpeg';
import styles from './ImageContainer.module.css';

type ImageContainerProps = {
  highlightImage: string | undefined;
  imageFill?: boolean | undefined | null;
};

export default function ImageContainer({ highlightImage, imageFill = false }: ImageContainerProps) {
  return (
    <div className={styles.imageContainer}>
      {highlightImage ? (
        <img
          src={highlightImage}
          alt="left banner"
          className={`${imageFill ? styles.imageFullWidth : styles.imageCenter}`}
        />
      ) : (
        <img
          src={HighlightAlterrnateImage}
          alt=""
          className={`${imageFill ? styles.imageFullWidth : styles.imageCenter}`}
        />
      )}
    </div>
  );
}
